module.exports = __webpack_public_path__ + "static/media/clients.915c1c3b.svg";